import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import Address from '../components/Address';
import Cta from '../components/Cta';

export class WidgetContainer extends React.Component {
	render() {
		const {
			dealerInfo,
			contactInfo,
			mapLink,
			prefs: {
				mapButtonStyle,
				mapButtonSize,
				mapButtonLayout,
				callButtonLayout,
				callButtonStyle,
				callButtonSize
			},
			labels: { CALL, GET_DIRECTIONS },
			requestData: { deviceType }
		} = this.props;

		const ctaProps = {
			contactInfo,
			mapLink,
			accountId: dealerInfo.accountId,
			ctaPrefs: {
				mapButtonStyle,
				mapButtonSize,
				mapButtonLayout,
				callButtonLayout,
				callButtonStyle,
				callButtonSize
			},
			ctaLabels: {
				CALL,
				GET_DIRECTIONS
			},
			isMobile: deviceType === 'MOBILE'
		};
		return (
			<React.Fragment>
				<Address {...dealerInfo} />
				<Cta {...ctaProps} />
			</React.Fragment>
		);
	}
}

WidgetContainer.propTypes = {
	dealerInfo: PropTypes.shape({
		name: PropTypes.string.isRequired,
		address1: PropTypes.string.isRequired,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
		postalCode: PropTypes.string.isRequired,
		url: PropTypes.shape({
			link: PropTypes.string,
			text: PropTypes.string
		}),
		accountId: PropTypes.string
	}).isRequired,
	contactInfo: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			number: PropTypes.string.isRequired
		})
	).isRequired,
	mapLink: PropTypes.string.isRequired,
	prefs: PropTypes.shape({
		mapButtonStyle: PropTypes.string,
		mapButtonSize: PropTypes.string,
		mapButtonLayout: PropTypes.string,
		callButtonLayout: PropTypes.string,
		callButtonStyle: PropTypes.string,
		callButtonSize: PropTypes.string
	}).isRequired,
	labels: PropTypes.shape({
		CALL: PropTypes.string,
		GET_DIRECTIONS: PropTypes.string
	}).isRequired,
	requestData: PropTypes.shape({
		deviceType: PropTypes.string.isRequired
	}).isRequired
};

const mapStateToProps = state => {
	return {
		...state
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx